// extracted by mini-css-extract-plugin
export default {"answerLine":"Faq_answerLine__ggUnd","faq":"Faq_faq__wwS3g","answer":"Faq_answer__QSHel","show":"Faq_show__7hJZ7"};